import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ajax from '@/utils/ajax';

import { Jurisdiction } from '../types/jurisdiction';

export const jurisdictionRepository = {
  async getJurisdictionList(host: string): Promise<Jurisdiction[]> {
    const path = `${host}/api/jurisdictions`;
    const response = await ajax.get({ url: path });

    return response.data;
  }
};

const JurisdictionRepository = (): { getJurisdictionList(): Promise<Jurisdiction[]> } => {
  const { host } = useContext(AppContext);
  return {
    async getJurisdictionList(): Promise<Jurisdiction[]> {
      return jurisdictionRepository.getJurisdictionList(host);
    }
  };
};

export default JurisdictionRepository;
